<template>
  <div class="container">
    <div class="signup-logo" style="margin-top: 56px">
      <img src="../../../assets/image/ic_logo@2x.png" style="width: 80px; height: 80px;"/>
    </div>
    <div>
      <div class="card_wrapper" >
        <input @change="onImageChange" type="file" name="file" accept="image/*" ref="img-file" style="display: none" />
        <template v-if="photo == ''">
          <div class="card_label">{{$t('signup_info.business_card_photo')}}</div>
          <b-button @click="onCard" class="card_btn card_btn_label">{{$t('signup_info.bs_regist')}}</b-button>
          <div class="card_guide">
            {{$t('signup_info.photo_guide')}}
            <br><p style="text-decoration: underline;">{{$t('signup_info.photo_guide2')}}</p>
          </div>
        </template>
        <template v-else>
          <b-img @click="onCard" :src="photo" style="width: 100%; height: 100%;"/>
        </template>
      </div>
    </div>
    <b-form-input v-model="affiliation" class="input input_wrapper" style="margin-top: 50px;padding-bottom: 15px;"
                  v-bind:placeholder="$t('signup_info.affiliation_placeholder')"/>
    <b-form-input v-model="name" class="input input_wrapper" style="margin-top: 45px;padding-bottom: 15px;" v-bind:placeholder="$t('signup_info.name_placeholder')"/>
    <b-input-group style="margin-top: 40px; align-items: flex-end">
      <b-form-input v-model="phone" :readonly="phoneCheck" class="input_wrapper input" :placeholder="$t('login.phone_placeholder')" :formatter="u.formatPhoneNumber"></b-form-input>
      <b-input-group-append>
        <b-button class="outline_btn btn_label" pill variant="white" @click="onPhoneNumber">{{$t('login.send_auth_num')}}</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-input-group style="margin-top: 40px;  align-items: flex-end">
      <b-form-input v-model="code"  class="input_wrapper input"  v-bind:placeholder="$t('login.auth_placeholder')" :formatter="u.formatNumber1"></b-form-input>
      <b-input-group-append>
        <label v-if="leftTime > 0" class="counter">{{timeStr()}}</label>
        <b-button class="outline_btn btn_label" pill variant="white" @click="onConfirmNumber">{{$t('login.confirm_num')}}</b-button>
      </b-input-group-append>
    </b-input-group>
    <div style="flex: 1"/>
    <b-button class="signup_btn signup_label" @click="onSignup">{{nextStep? $t('signup_info.next_step'): $t('login.signup')}}</b-button>
 <SignupQuizPopup
   :visible.sync="showSignupQuiz"
   :info="info"
 />
  </div>
</template>

<script>
import Utils from "../../../config/utils";
import SignupQuizPopup from "../../controls/popup/SignupQuizPopup";

export default {
  name: "SignupInfo",
  components:{
    SignupQuizPopup,
  },
  data () {
    return {
      u:Utils,
      photo:'',
      affiliation: '',
      name: '',
      phone: '',
      code: '',
      leftTime: 0,
      phoneCheck: false,
      nextStep: true,
      showSignupQuiz:false,
      info:null,
    }
  },
  methods:{
    onCard(){
      this.$refs["img-file"].click();
    },
    onImageChange(){
      let file = this.$refs['img-file'].files[0];
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.photo = result.data.url;
        } else {
          Utils.toast(this,result.msg);
        }
      });

    },
    timeStr() {
      return Utils.formatTime(this.leftTime);
    },
    startTimer() {
      this.leftTime = 180;
      this.timer = setInterval(() => {
        this.leftTime--;
        if (this.leftTime == 0)
          this.stopTimer();
      }, 1000);
    },
    stopTimer() {
      if (this.timer != null)
        clearInterval(this.timer);
      this.leftTime = 0;
      this.sendAuth = false;
    },
    onPhoneNumber() {
      if(this.phoneCheck){
        return;
      }
      if (this.phone === '') {
        Utils.toast(this, this.$t('login.phone_placeholder'));
        return;
      }
      Utils.requestPost(this.$c.API.Auth.authPhone, {
        phone_number: this.phone.replace(new RegExp(/-/g), '')
      }).then(result => {
        if (result == null)
          return;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          if (result.data.auth == 'Y') {
            this.phoneCheck = true;
            this.code="123456";
            this.nextStep = result.data.auth == 'N';
            Utils.toast(this, this.$t('signup_info.cert_match_admin'));
          }else{
            Utils.toast(this, this.$t('login.auth_num_sent'));
            this.startTimer();
          }
        } else {
          if (this.leftTime < 1) {
            this.sendAuth = false;
          }
          Utils.toast(this, result.msg);
        }
      }).catch(err => {
        Utils.toast(this, this.$t('app_error.network'));
      });
    },
    onConfirmNumber() {
      if(this.phoneCheck){
        Utils.toast(this, this.$t('login.auth_num_request'));
        return;
      }
      if (this.code === '') {
        Utils.toast(this, this.$t('login.auth_placeholder'));
        return;
      }
      if (this.leftTime < 1) {
        Utils.toast(this, this.$t('login.time_out'));
        return;
      }
      Utils.requestPost(this.$c.API.Auth.checkPhoneAuthCode,
        {
        phone_number: this.phone.replace(new RegExp(/-/g), ''),
        code:this.code,
      }).then(result => {
        if (result == null)
          return;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.phoneCheck = true;
            this.nextStep = result.data.auth == 'N';
            Utils.toast(this, this.$t('signup_info.cert_match'));
            this.stopTimer();
        } else {
          Utils.toast(this, this.$t('signup_info.cert_not_match'));
        }
      }).catch(err => {
        Utils.toast(this, this.$t('app_error.network'));
      });

    },
    onSignup(){
      const {affiliation, name, phone, code, photo, phoneCheck, nextStep} = this;

      if (photo == '') {
        Utils.toast(this, this.$t('signup_info.pick_card_photo'));
        return;
      }
      if (affiliation == '') {
        Utils.toast(this, this.$t('signup_info.affiliation_placeholder'));
        return;
      }
      if (name == '') {
        Utils.toast(this, this.$t('signup_info.name_placeholder'));
        return;
      }
      if (phone == '' || code == '') {
        Utils.toast(this, this.$t('signup_info.all_info'));
        return;
      }
      if (!phoneCheck) {
        Utils.toast(this, this.$t('signup_info.auth_phone'));
        return;
      }

      if (nextStep) {
          this.info = {
            business_card: photo,
            affiliation: affiliation,
            name: name,
            phone_number: phone.replaceAll('-', ''),
            code: code,
            device_id: this.$perf.uuid(),
            // fcm_token: this.$perf.fcm_token()
          }
        this.showSignupQuiz = true;
      } else {
        Utils.requestPost(
          this.$c.API.Auth.signUp,
          {
            business_card: photo,
            affiliation: affiliation,
            name: name,
            phone_number: phone.replaceAll('-', ''),
            device_id: this.$perf.uuid(),
            // fcm_token: this.$perf.fcm_token()
          }
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            if (result.data == null) {
              this.$router.back();
              return;
            }
            this.myinfo.accessToken = result.data.access_token;
            this.$perf.setString(this.$c.PREF_PARAMS.PHONE, phone.replaceAll('-', ''));
            this.$perf.setString(this.$c.PREF_PARAMS.CODE, code);
            this.getProfile();
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }
    },
    getProfile(){
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.myinfo.saveInfo();
          // this.myinfo.loadInfo();
          this.$router.push('home');
        } else {
          Utils.toast(this, result.msg);
        }
      });
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/auth/SignupInfo";


</style>



// WEBPACK FOOTER //
// src/components/contents/auth/SignupInfo.vue